export default {"src":"/_next/static/image/public/assets/icons/chat.a6ca2552edca8654bc91d23a049ef7e1.svg","height":20,"width":20};